// src/utils/notifications.ts
import React from 'react';
import { message, notification } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

interface NotificationOptions {
  title?: string;
  description?: string;
  duration?: number;
  placement?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
}

const getIcon = (type: NotificationType) => {
  const iconProps = { style: { color: type === 'success' ? '#7CB342' : type === 'error' ? '#ff4d4f' : type === 'warning' ? '#faad14' : '#42A5F5' } };
  switch (type) {
    case 'success':
      return React.createElement(CheckCircleOutlined, iconProps);
    case 'error':
      return React.createElement(CloseCircleOutlined, iconProps);
    case 'warning':
      return React.createElement(ExclamationCircleOutlined, iconProps);
    case 'info':
      return React.createElement(InfoCircleOutlined, iconProps);
  }
};

export const showNotification = (
  type: NotificationType,
  message: string,
  options?: NotificationOptions
) => {
  notification[type]({
    message: options?.title || message,
    description: options?.description,
    icon: getIcon(type),
    duration: options?.duration || 4.5,
    placement: options?.placement || 'topRight',
  });
};

export const showSuccess = (msg: string, options?: NotificationOptions) => {
  showNotification('success', msg, options);
};

export const showError = (msg: string, options?: NotificationOptions) => {
  showNotification('error', msg, options);
};

export const showWarning = (msg: string, options?: NotificationOptions) => {
  showNotification('warning', msg, options);
};

export const showInfo = (msg: string, options?: NotificationOptions) => {
  showNotification('info', msg, options);
};

// Toast notifications with better styling
export const showToast = {
  success: (content: string, duration = 3) => {
    message.success({
      content,
      duration,
      style: {
        marginTop: '20vh',
      },
    });
  },
  error: (content: string, duration = 4) => {
    message.error({
      content,
      duration,
      style: {
        marginTop: '20vh',
      },
    });
  },
  warning: (content: string, duration = 3) => {
    message.warning({
      content,
      duration,
      style: {
        marginTop: '20vh',
      },
    });
  },
  info: (content: string, duration = 3) => {
    message.info({
      content,
      duration,
      style: {
        marginTop: '20vh',
      },
    });
  },
};
